"use client";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";

/**
 * @brief Root router (LOOP 3 / iter17).
 *
 * Order of precedence:
 *   1. /api/first-run/status.needed → /first-run (always wins)
 *   2. unauthenticated → /login
 *   3. admin → /admin/system
 *   4. user without onboarding → /onboarding
 *   5. otherwise → /workspace
 */

export default function Home() {
  const router = useRouter();
  const [phase, setPhase] = useState<string>("loading");

  useEffect(() => {
    (async () => {
      try {
        const fr = await fetch("/api/first-run/status").then((r) => (r.ok ? r.json() : null));
        if (fr?.needed) {
          setPhase("→ /first-run");
          router.replace("/first-run");
          return;
        }
      } catch {
        /* fall through to auth check */
      }
      const u = await fetch("/api/auth/me", { credentials: "include" }).then((r) =>
        r.ok ? r.json() : null
      );
      if (!u) {
        setPhase("→ /login");
        router.replace("/login");
      } else if (u.role === "admin" || u.role === "super_admin") {
        setPhase("→ /admin/system");
        router.replace("/admin/system");
      } else if (!u.onboarded) {
        setPhase("→ /onboarding");
        router.replace("/onboarding");
      } else {
        setPhase("→ /workspace");
        router.replace("/workspace");
      }
    })();
  }, [router]);

  return (
    <main className="onb">
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 14 }}>
        {/* Post-login redirect screen — spinner only. The logo previously
            stacked above the spinner read as a content card, which made
            this transient screen feel heavier than it should. */}
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src="/brand/dr-lee-spinner.svg"
          alt=""
          aria-hidden="true"
          style={{ width: 60, height: 20, display: "block" }}
        />
        <div className="placeholder">{phase}</div>
      </div>
    </main>
  );
}
